import { post,postAES } from '../request'

// 列表
export const getAuctionList = params => postAES('v3/session/special/list', params)
// 聚合列表
export const getBidAuctionList = params => postAES('v3/bid/session/special/list', params)
// 搜索
export const searchOptions = params => post('v2/special/search/bar', params)
// 畅拍页列表
// export const getChangPaiList = params => postAES('v3/session/special/list/new', params)
export const getChangPaiList = params => post('v2/session/special/list/new', params)

// 搜索列表获取数量
export const searchAuctionList = params => post('v2/special/search/count', params)
// 搜索列表获取数量 拍品
export const searchLotList = params => post('v2/auction/search/count', params)

// 关注
export const focusOn = params => post('v2/special/focus', params)